import { HighlightedText } from "../../../Utils/CommonFunctions";

import Button from "../../CommonComponents/Button";
import CardDesign from "../CommonComponents/CardDesign";

import PopularCategorySection from "./PopularCategorySection";
import PopularRetailer from "./PopularRetailer";
import WhatNewSection from "./WhatNewSection";

const RewardComponents = {
  gift_card: ({ data, ...props }) => (
    <CardDesign
      initialModuleName="Top"
      cardType="giftcard"
      cardIconType="giftcard"
      cardNameType="Gift Cards"
      data={data}
      showArrow={true}
      {...props}
    />
  ),
  merchant_funded_offers: ({ data, ...props }) => (
    <CardDesign
      initialModuleName="Top"
      cardType="discountOffer"
      data={data}
      showArrow={true}
      {...props}
    />
  ),
  affiliate_cashback: ({ data, ...props }) => (
    <CardDesign
      initialModuleName="Latest"
      cardType="cashbackOffer"
      data={data}
      showArrow={true}
      {...props}
    />
  ),
  access_n_membership: ({ data, ...props }) => (
    <CardDesign
      initialModuleName=""
      cardType="accessNmembership"
      data={data}
      showArrow={true}
      {...props}
    />
  ),
  experiences: ({ data, ...props }) => (
    <CardDesign
      initialModuleName=""
      cardType="amazingExperinces"
      data={data}
      showArrow={true}
      {...props}
    />
  )
};

export default function RewardSection({ isAuthenticated, handleLinkClick, isMobile, subVarientIdGlobal, integratorTheme, handleViewButton, subModuleArray, whatsNewCardData, popularCategoryData, discountCardData, cashbackCardData, giftCardData, accessNmembershipData, ExperienceCardData, brandListData, isLoading, RewardSubDomain }) {

  // Common props for all components
  const commonProps = {
    handleLinkClick,
    isAuthenticated
  };

  // Data mapping for submodules
  const submoduleDataMap = {
    gift_card: giftCardData,
    merchant_funded_offers: discountCardData,
    affiliate_cashback: cashbackCardData,
    access_n_membership: accessNmembershipData,
    experiences: ExperienceCardData
  };

  return (
    <>
      {/* Always render these sections for rewards */}
      <WhatNewSection
        subVarientIdGlobal={subVarientIdGlobal}
        whatsNewCardData={whatsNewCardData}
        isLoading={isLoading}
        {...commonProps}
      />

      {popularCategoryData && (
        <PopularCategorySection
          isMobile={isMobile}
          popularCategoryData={popularCategoryData}
          isLoading={isLoading}
          {...commonProps}
        />
      )}

      <div className="container flex md:pb-8 mt-10 md:mt-8 flex-col pl-5 -pr-5 md:px-5 mx-auto relative">
        <div className="flex gap-2.5 items-start md:items-center justify-between">
          <div className="flex gap-2.5 items-center">
            <div className="flex flex-col gap-0 md:gap-1">
              {integratorTheme?.reward_module_title !== null ? (
                <div className="font-Inter text-2xl md:text-4xl font-semibold">
                  <HighlightedText text={integratorTheme?.reward_module_title || "Unveil the Magic of Rewards"} integratorTheme={integratorTheme} />
                </div>
              ) : (
                <div className="font-Inter text-2xl md:text-4xl font-semibold">Unveil the Magic of Rewards</div>
              )}
              {integratorTheme?.reward_module_subtitle !== null ? (
                <div className="font-Inter">
                  <HighlightedText text={integratorTheme?.reward_module_subtitle || "Amplify your savings with smartbuy accelerated points"} integratorTheme={integratorTheme} />
                </div>
              ) : (
                <div className="font-Inter">Amplify your savings with smartbuy accelerated points </div>
              )}
            </div>
          </div>
          <Button
            variant="primary"
            size="sm"
            theme={integratorTheme}
            className="md:px-5 hidden md:block mr-2 md:mr-0 text-base font-medium h-auto p-2.5 md:py-0 w-[150px] md:w-auto md:h-10"
            onClick={() => handleViewButton("rewards")}
          >
            View All
          </Button>
        </div>
        <div className="flex justify-end">
          <Button
            variant="primary"
            size="sm"
            theme={integratorTheme}
            className="md:px-5 mt-2 block md:hidden mr-2 md:mr-0 text-base font-medium h-auto p-2.5 md:py-0 w-fit md:w-auto md:h-10"
            onClick={() => handleViewButton("rewards")}
          >
            View All
          </Button>
        </div>
      </div>

      {/* Render submodule components */}
      {subModuleArray.map(submodule => {
        const Component = RewardComponents[submodule];

        if (!Component) return null;

        return (
          <Component
            key={submodule}
            data={submoduleDataMap[submodule]}
            isLoading={isLoading}
            {...commonProps}
          />
        );
      })}

      {/* Experience carousal only for rewards subdomain */}
      {RewardSubDomain && (
        <CardDesign
          initialModuleName=""
          cardType="amazingExperinces"
          data={ExperienceCardData}
          showArrow={true}
          {...commonProps}
        />
      )}

      {brandListData && (
        <PopularRetailer
          isMobile={isMobile}
          brandListData={brandListData}
          isLoading={isLoading}
        />
      )}
    </>
  );
}
